/**
 * @fileoverview Barrel exports for the character-extractor-targeted-v2 agent.
 */

// Agent definition
export { definition } from './definition';

// Schemas and types
export {
  InputSchema,
  OutputSchema,
  type Input,
  type Output,
} from './schema';

// Flow
export { flow, characterExtractorTargetedV2AgentFlow } from './flow';

// Prompt template
export { prompt } from './prompt';
